/* "Matching tartan" choice inside an accessory group (sporrans, flashes, fly plaids): exclusive with the catalogue styles in that group. */
(function () {
  document.querySelectorAll('[data-a1-matching]').forEach(function (cb) {
    var group = cb.closest('[data-a1-accessory-group]');
    if (!group) return;
    var none = group.querySelector('input[type="radio"]');
    cb.addEventListener('change', function () {
      if (cb.checked && none) { none.checked = true; none.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    group.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"]') && e.target.value !== '' && cb.checked) {
        cb.checked = false;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
})();
